import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AcademicType } from 'src/app/_enums/academic-type.enum';
import { Observable, observable } from 'rxjs';
import { AcademicItem } from 'src/app/_models/academic/grading-assessment/academics-items.interface';
import { MainFiltersService } from '../main-filters.service';
import { honorRollSetup } from 'src/app/_models/academic/grading-assessment/honorRollSetup.interface';
import { AssessmentWeightSetting } from 'src/app/pages/academic/grading-assessments/grade-setup/manage-weights/manage-weights.component';

@Injectable({
  providedIn: 'root'
})
export class GradingAssessmentsService {

  private url = environment.apiUrl;
  private academicTypeEnum = AcademicType;
  clickedSectionId: number = 0;

  constructor(private http: HttpClient) {}

  getStudentAssessments(filter) {
    return this.http.get('/assets/api/studentAssessments.json');
  }
  
  getStudentCceAssessments(filter) {
    return this.http.get('/assets/api/cceAssessment.json');
  }
  
  getAssessmentsBySubject(subjectId) {
    return this.http.get('/assets/api/assessmentsBySubject.json');
  }
 
  getAllVirtualPoints() {
    return this.http.get('/assets/api/virtualPoints.json');
  }

  getNewRubrics() {
    return this.http.get('/assets/api/rubric.json');
  }

  getNewPercentages() {
    return this.http.get('/assets/api/percentage.json');
  }
  getNewPassFail() {
    return this.http.get('/assets/api/pass-fail.json');
  }

  getNewGrades() {
      return this.http.get('/assets/api/grade.json');
  }

  

  getAllGrades(typeId = null, yearId = null, semsterId = null) {
    
    if (typeId === null)
      return this.http.get('/assets/api/grade.json');

      let queryString = `typeId=${typeId}`;

      if (yearId)
        queryString += `&yearId=${yearId}`;

      if (semsterId)
        queryString += `&semsterId=${semsterId}`;

    return this.http.get(`${this.url}AssessmentAndGrades/GetAllGradeByTypeId?${queryString}`);
  }


  getAcademics(yearId: number) {
      return this.http.get(`${this.url}Stages/AcademicDataForWeight/${yearId}`);
  }

  saveAssessmentCategoryWeight(weightObj, sectionSubjectId?: number) {
    if (sectionSubjectId)
      return this.http.post(`${this.url}AssessmentAndGrades/SaveAssessmentCategoryWeight?sectionSubjectId=${sectionSubjectId}`, weightObj);
    else
      return this.http.post(`${this.url}AssessmentAndGrades/SaveAssessmentCategoryWeight`, weightObj);
  }

  getWeight(yearId: number, selectedAcademicType: AcademicType, itm: AcademicItem) {
    if (selectedAcademicType === this.academicTypeEnum.stage)
      return this.http.get('/assets/api/academicsCategories.json');
    if (selectedAcademicType === 2)
      return this.http.get(`${this.url}Classes/GetClassesAndWeight/${yearId}/${itm.id}`);
    if (selectedAcademicType === this.academicTypeEnum.section)
      return this.http.get(`${this.url}Sections/GetSectionsAndWeight/${itm.id}`);
    if (selectedAcademicType === this.academicTypeEnum.subject)
      return this.http.get(`${this.url}Subjects/GetSubjectsAndWeight/${itm.id}`);
  }

  addOrUpdateWeightSetting(assessmentWeightSetting: AssessmentWeightSetting) {
    return this.http.post(`${this.url}AssessmentAndGrades/AddOrUpdateWeightSetting`, assessmentWeightSetting);
  }
 
  isThereIsWeightConfiguration() {
    return this.http.get(`${this.url}AssessmentAndGrades/IsThereIsWeightConfiguration`);
  }

  getAssessmentCategoryAndWeightsForAll() {
    return this.http.get(`${this.url}/AssessmentAndGrades/GetAssessmentCategoryAndWeightsForAll`);
}

getAssessmentCategoryAndWeightsForSectionSubject(sectionSubjectId: number) {
  return this.http.get(`${this.url}/AssessmentAndGrades/GetAssessmentCategoryAndWeightsForSectionSubject/${sectionSubjectId}`);
}
copyWeight(sectionSubjectId: number, selectedIds:number[]) {
  let obj =
  {
    CopyFromSectionSubjectsId : sectionSubjectId,
    CopyToSectionSubjectIds:selectedIds

  }
  return this.http.post(`${this.url}/AssessmentAndGrades/CopyWeight`, obj);
}


getGradeScaleById(gradeScaleId:number)
{
  return this.http.get(`${this.url}/AssessmentAndGrades/GetGradeScaleById/${gradeScaleId}`);
}

 addGradeScale(scale) {
   
    return this.http.post(`${this.url}AssessmentAndGrades/CreateGradeScale`, scale);
  }

 updateGradeScale(scale) {
    return this.http.put(`${this.url}AssessmentAndGrades/UpdateGradeScale`, scale);
  }
 
 deleteGradeSclae(scaleId: number) {
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteGradeScale/${scaleId}`);
 }
  CreateOverallScoreSettings(obj) {
    return this.http.post(`${this.url}AssessmentAndGrades/CreateOverallScoreSettings`, obj);
  }
  UpdateOverallScoreSettings(obj) {
    return this.http.put(`${this.url}AssessmentAndGrades/UpdateOverallScoreSettings`, obj);
  }
  GetOverallScoreSettingsById(id: number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetOverallScoreSettingsById/${id}`);
  }

  GetAllOverallScoreSettings(isGpaOverall:boolean) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAllOverallScoreSettings?isGpaOverall=${isGpaOverall}`);
  }

  DeleteOverallScoreSettings(id: number) {
    return this.http.delete(`${this.url}AssessmentAndGrades/DeleteOverallScoreSettings/${id}`);
  }
  
 getAllHonourSettingTypeId() {
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllHonourSettingTypes`);
}

saveHonourSetting(setting: honorRollSetup) {
  return this.http.post(`${this.url}AssessmentAndGrades/SaveHonorSettings`, setting);
}

getAllHonourSetting() {
  
  return this.http.get(`${this.url}AssessmentAndGrades/GetHonorSettings?typeIds=1&typeIds=2&typeIds=3`);
}
getHonourSettingById(id : number) {
  
  return this.http.get(`${this.url}AssessmentAndGrades/GetHonorSettingsById/${id}`);
}

deleteHonorSettings(id :number)
{
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteHonorSettings/${id}`);
}
getAllGradeScaleType() {
  
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllGradeScaleType`);
}

getAllOverallSectionSubjects(queryString) {
  
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllOverallSectionSubjects?${queryString}`);
}


/**** assessments ****/
getAllAssessment()
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllAssessment`);
}
getAssessmentById(assessmentId:number)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAssessmentById/${assessmentId}`);
}
createAssessment(assessmentModel) {
return this.http.post(`${this.url}AssessmentAndGrades/CreateAssessment`, assessmentModel);
}
updateAssessment(assessmentModel) {
return this.http.put(`${this.url}AssessmentAndGrades/UpdateAssessment`, assessmentModel);
}

deleteAssessment(assessmentId)
{
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAssessment/${assessmentId}`);
}

getAllAsmtCceMainCriteria(assessmentId)
{
  return this.http.get(`${this.url}AssessmentAndGrades/getAllAsmtCceMainCriteria?asmtId=${assessmentId}`);
}

getCceMainCriteriaNotConnectedWithAsmt(assessmentId)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetCceMainCriteriaNotConnectedWithAsmt?asmtId=${assessmentId}`);
}

createAsmtCceMainCriteria(obj)
{
  return this.http.post(`${this.url}AssessmentAndGrades/CreateAsmtCceMainCriteria`, obj);
}
updateAsmtCceMainCriteria(obj)
{
  return this.http.put(`${this.url}AssessmentAndGrades/UpdateAsmtCceMainCriteria`, obj);
}
getAsmtCceMainCriteriaById(id)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAsmtCceMainCriteriaById?id=${id}`);
}
deleteAsmtCceMainCriteria(id)
{
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAsmtCceMainCriteria?id=${id}`);
}
getAllAsmtSubCriteriaByAsmtMainCriteriaId(id)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllAsmtSubCriteriaByAsmtMainCriteriaId?asmtMainCrId=${id}`);
}

createAsmtSubCriteria(obj)
{
  return this.http.post(`${this.url}AssessmentAndGrades/CreateAsmtSubCriteria`, obj);
}
updateAsmtSubCriteria(obj)
{
  return this.http.put(`${this.url}AssessmentAndGrades/UpdateAsmtSubCriteria`, obj);
}
getAsmtSubCriteriaById(id)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAsmtSubCriteriaById?id=${id}`);
}
deleteAsmtSubCriteria(id)
{
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAsmtSubCriteria?id=${id}`);
}
/**** end assessments ****/

/****** assessments categories****/
getAllAssessmentCategories()
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllAssessmentCategories`);
}
createAssessmentCategories(obj)
{
  return this.http.post(`${this.url}AssessmentAndGrades/CreateAssessmentCategories`, obj);
}
updateAssessmentCategories(obj)
{
  return this.http.put(`${this.url}AssessmentAndGrades/UpdateAssessmentCategories`, obj);
}
deleteAssessmentCategories(Id: number) 
{
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAssessmentCategories/${Id}`);
}

/****** End assessments categories****/


/***** Audit analysis *****/
getAuditAnalysisData(asmtCategoryId:number, asmtId:number, parentSubjectId:number, classId:number, sectionId:number, 
  teacherId:number, considerOptionalSubCriteria:boolean, pageIndex:number, pageSize:number, getAllAsmtCategories:boolean) {
  
  let req =   `${this.url}/GradeAudit/GetAuditAnalysisData?getAllAsmtCategories=${getAllAsmtCategories}`;

if(asmtCategoryId)
req += `&asmtCategoryId=${asmtCategoryId}`;

if(asmtId)
req += `&asmtId=${asmtId}`;

if(parentSubjectId && parentSubjectId !== -1)
req += `&parentSubjectId=${parentSubjectId}`;

if(classId)
req += `&classId=${classId}`;

if(sectionId)
req += `&sectionId=${sectionId}`;

if(teacherId)
req += `&teacherId=${teacherId}`;

if(considerOptionalSubCriteria)
req += `&considerOptionalSubCriteria=${considerOptionalSubCriteria}`;

if(pageIndex || pageIndex == 0)
req += `&pageIndex=${pageIndex}`;

if(pageSize)
req += `&pageSize=${pageSize}`;

  return this.http.get(req);
}

getAssessmentsByCategoryId(id: number)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAssessmentsByCategoryId?asmtCategoryId=${id}`);
}
getSubjectsByAssessmentId(id: number)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetSubjectsByAssessmentId?asmtId=${id}`);
}

getAssessmentsBySectionId(sectionId: number){
  return this.http.get(`${this.url}/AssessmentAndGrades/GetSectionSummaryData?sectionId=${sectionId}`);
}

getAllTeacherBySection(id:number)
{
  return this.http.get(`${this.url}Users/GetAllTeacherBySection/${id}`);
}

getStudentAssessmentForAuditing(sectionId:number, asmtId:number, sectionSubjectId:number)
{
  return this.http.get(`${this.url}/GradeAudit/GetStudentAssessmentForAuditing?sectionId=${sectionId}&asmtId=${asmtId}&sectionSubjectId=${sectionSubjectId}`);
}

auditStudentAssessment(ids, approved)
{
  let obj = {
    studentAssessmentIds:ids , 
    isApproved:approved
  }
  return this.http.post(`${this.url}GradeAudit/AuditStudentAssessment`, obj);
  
}



/***** End Audit analysis *****/




/***** Report Card Services****/
getReportStudentInfo(id:number)
{
  return this.http.get(`${this.url}ReportCard/GetReportStudentInfo?studentId=${id}`);
}

getGradeScaleByClassId(id:number)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetGradeScaleByClassId?classId=${id}`);
}
getReportData(id:number,reportType:number = 1 )
{
  return this.http.get(`${this.url}ReportCard/GetReportData?studentId=${id}&reportType=${reportType}`);
}

/**** progress report ****/

getProgressAssessmentCategoriesData(studentId:string)
{
 // return this.http.get(`${this.url}ReportCard/GetProgressAssessmentCategoriesData?studentId=${studentId}`);

 return Observable.of([
   {
    assessmentCategories:  [
      {
        assessmentCategoryId: 1,
        assessments: [
          {
            assessmentCategoryId: 0,
            assessmentId: 1,
            assessmentName: "assmt 1",
            assessmentNameLatin: "assmt 1",
            mark: null,
            progressCceMainCriteria: [],
            studentAssessmentId: 0
          },
          {
            assessmentCategoryId: 0,
            assessmentId: 2,
            assessmentName: "assmt 2",
            assessmentNameLatin: "assmt 2",
            mark: null,
            progressCceMainCriteria: [],
            studentAssessmentId: 0
          }
        ],
        name: "assmt cat 1",
        nameLatin: "assmt cat 1",
        score: 0
      },

      {
        assessmentCategories: [],
        average: null,
        endDate: "2020-05-30T00:00:00+03:00",
        isActive: false,
        name: "الفصل الثاني",
        nameLatin: "Second Semester",
        semesterId: 2,
        startDate: "2020-02-01T00:00:00+02:00",
        subjects: [],
        weeksNumber: 0
      }
    ],
    average: null,
    endDate: "2019-12-31T00:00:00+02:00",
    isActive: false,
    name: "الفصل الاول",
    nameLatin: "First Semester",
    semesterId: 1,
    startDate: "2019-09-20T00:00:00+03:00",
    subjects: [],
    weeksNumber: 0
   }
 ])
}

getProgressData(studentId:string)
{
  return Observable.of([
    {
      semesterId: 1 ,
      name: " sem 1" ,
      nameLatin: "sem 1" ,
      startDate: "dsdfsdfdsf" ,
      endDate: "SDfsdfsdf" , 
      isActive: true ,
      subjects: [
        {
          sectionSubjectId: 1,
          parentSubjectNameLatin: "subject Name 1",
          parentSubjectName: "subject Name 1",
          parentSubjectId: 1,
          studentAssessments: [
            {
              studentAssessmentId: 0,
              assessmentId: 1,
              assessmentName: "asmt 1",
              assessmentNameLatin: "asmt 1",
              assessmentCategoryId: 1,
              mark : 111,
              ProgressCceMainCriteria: []
            },
            {
              studentAssessmentId: 0,
              assessmentId: 2,
              assessmentName: "asmt 2",
              assessmentNameLatin: "asmt 2",
              assessmentCategoryId: 1,
              mark : 2222,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "asmt 2 cce main",
                  nameLatin: "asmt 2 cce main latin",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "asmt 2 sub name 1",
                      nameLatin: "asmt 2 sub name 1",
                      mark: 22
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "asmt 2 sub name 2",
                      nameLatin: "asmt 2 sub name 2",
                      mark: 22
                    }
                  ]
                }
              ]
            },
            {
              studentAssessmentId: 0,
              assessmentId: 3,
              assessmentName: "asmt 3",
              assessmentNameLatin: "asmt 3",
              assessmentCategoryId: 2,
              mark : 333,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "asmt 3 cce main 15",
                  nameLatin: "asmt 3 cce main latin 15",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "asmt 3 sub name 1",
                      nameLatin: "asmt 3 sub name 1",
                      mark: 33
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "asmt 3 sub name 2",
                      nameLatin: "asmt 3 sub name 2",
                      mark: 33
                    }
                  ]
                }
              ]
            },
            {
              studentAssessmentId: 0,
              assessmentId: 4,
              assessmentName: "asmt 4",
              assessmentNameLatin: "asmt 4",
              assessmentCategoryId: 2,
              mark : 444,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "asmt 4 cce main 15",
                  nameLatin: "asmt 4 cce main latin 15",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "asmt 4 sub name 1",
                      nameLatin: "asmt 4 sub name 1",
                      mark: 44
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "asmt 4 sub name 2",
                      nameLatin: "asmt 4 sub name 2",
                      mark: 44
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          sectionSubjectId: 1,
          parentSubjectNameLatin: "subject Name 2",
          parentSubjectName: "subject Name 2",
          parentSubjectId: 1,
          studentAssessments: [
            {
              studentAssessmentId: 0,
              assessmentId: 1,
              assessmentName: "asmt 1",
              assessmentNameLatin: "asmt 1",
              assessmentCategoryId: 1,
              mark : 70,
              progressCceMainCriteria: []
            },
            {
              studentAssessmentId: 0,
              assessmentId: 3,
              assessmentName: "asmt 2",
              assessmentNameLatin: "asmt 2",
              assessmentCategoryId: 1,
              mark : 30,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main",
                  nameLatin: "cce main latin",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 1",
                      nameLatin: "sub name 1",
                      mark: 10
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 2",
                      mark: 10
                    }
                  ]
                }
              ]
            },
            {
              studentAssessmentId: 0,
              assessmentId: 2,
              assessmentName: "asmt 3",
              assessmentNameLatin: "asmt 4",
              assessmentCategoryId: 1,
              mark : 50,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main 15",
                  nameLatin: "cce main latin 15",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 1",
                      mark: 50
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 3",
                      nameLatin: "sub name 3",
                      mark: 20
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },

    {
      semesterId: 2 ,
      name: " sem 1" ,
      nameLatin: "sem 1" ,
      startDate: "dsdfsdfdsf" ,
      endDate: "SDfsdfsdf" , 
      isActive: true ,
      subjects: [
        {
          sectionSubjectId: 1,
          parentSubjectNameLatin: "subject Name 1",
          parentSubjectName: "subject Name 1",
          parentSubjectId: 1,
          studentAssessments: [
            {
              studentAssessmentId: 0,
              assessmentId: 1,
              assessmentName: "asmt 1",
              assessmentNameLatin: "asmt 1",
              assessmentCategoryId: 1,
              mark : 50,
              progressCceMainCriteria: []
            },
            {
              studentAssessmentId: 0,
              assessmentId: 2,
              assessmentName: "asmt 2",
              assessmentNameLatin: "asmt 2",
              assessmentCategoryId: 1,
              mark : 50,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main",
                  nameLatin: "cce main latin",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 1",
                      nameLatin: "sub name 1",
                      mark: 150
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 2",
                      mark: 300
                    }
                  ]
                }
              ]
            },
            {
              studentAssessmentId: 0,
              assessmentId: 3,
              assessmentName: "asmt 3",
              assessmentNameLatin: "asmt 4",
              assessmentCategoryId: 2,
              mark : 50,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main 15",
                  nameLatin: "cce main latin 15",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 1",
                      mark: 50
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 3",
                      nameLatin: "sub name 3",
                      mark: 20
                    }
                  ]
                }
              ]
            },
            {
              studentAssessmentId: 0,
              assessmentId: 4,
              assessmentName: "asmt 3",
              assessmentNameLatin: "asmt 4",
              assessmentCategoryId: 2,
              mark : 50,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main 15",
                  nameLatin: "cce main latin 15",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 1",
                      mark: 50
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 3",
                      nameLatin: "sub name 3",
                      mark: 20
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          sectionSubjectId: 1,
          parentSubjectNameLatin: "subject Name 2",
          parentSubjectName: "subject Name 2",
          parentSubjectId: 1,
          studentAssessments: [
            {
              studentAssessmentId: 0,
              assessmentId: 1,
              assessmentName: "asmt 1",
              assessmentNameLatin: "asmt 1",
              assessmentCategoryId: 1,
              mark : 70,
              progressCceMainCriteria: []
            },
            {
              studentAssessmentId: 0,
              assessmentId: 1,
              assessmentName: "asmt 2",
              assessmentNameLatin: "asmt 2",
              assessmentCategoryId: 1,
              mark : 30,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main",
                  nameLatin: "cce main latin",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 1",
                      nameLatin: "sub name 1",
                      mark: 10
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 2",
                      mark: 10
                    }
                  ]
                }
              ]
            },
            {
              studentAssessmentId: 0,
              assessmentId: 1,
              assessmentName: "asmt 3",
              assessmentNameLatin: "asmt 4",
              assessmentCategoryId: 1,
              mark : 50,
              progressCceMainCriteria: [
                {
                  cceMainCriteriaId: 1,
                  name: "cce main 15",
                  nameLatin: "cce main latin 15",
                  progressCceSubCriteria: [
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 2",
                      nameLatin: "sub name 1",
                      mark: 50
                    },
                    {
                      cceSubCriteriaId: 1,
                      name: "sub name 3",
                      nameLatin: "sub name 3",
                      mark: 20
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ])


  // return this.http.get(`${this.url}ReportCard/GetProgressData?studentId=${studentId}`);
}
/**** end progress report ****/

/**** Main Criteria ****/
getAllCceMainCriteria()
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllCceMainCriteria`);
}

getCceMainCriteriaById(id)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetCceMainCriteriaById?id=${id}`);
}

createCceMainCriteria(cceMainCriteria) {
   
  return this.http.post(`${this.url}AssessmentAndGrades/CreateCceMainCriteria`, cceMainCriteria);
}

updateCceMainCriteria(cceMainCriteria)
{
  return this.http.put(`${this.url}AssessmentAndGrades/UpdateCceMainCriteria`, cceMainCriteria);
}

deleteCceMainCriteria(id: number) {
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteCceMainCriteria?id=${id}`);
 }

/**** Main Criteria ****/

/**** Alternate grades ****/
getAllAlternateGrade()
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAllAlternateGrade`);
}

getAlternateGradeById(id)
{
  return this.http.get(`${this.url}AssessmentAndGrades/GetAlternateGradeById?id=${id}`);
}

createAlternateGrade(alternateGrade) {
   
  return this.http.post(`${this.url}AssessmentAndGrades/CreateAlternateGrade`, alternateGrade);
}

updateAlternateGrade(alternateGrade)
{
  return this.http.put(`${this.url}AssessmentAndGrades/UpdateAlternateGrade`, alternateGrade);
}

deleteAlternateGrade(id: number) {
  return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAlternateGrade?id=${id}`);
 }

/**** Alternate grades ****/

/***** End Report Card Services****/

}
